import React from "react";
import { LogOut, UserIcon } from "lucide-react";
import { Button, Dialog, DialogContent } from "@ui";
import { User } from "@auth0/auth0-react";

interface ModalLogoutProps {
  open: boolean;
  logout: () => void;
  user: User | undefined;
  onOpenChange: (open: boolean) => void;
}

export const ModalLogout: React.FC<ModalLogoutProps> = ({
  open,
  logout,
  user,
  onOpenChange,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="!rounded-[20px] sm:max-w-[400px] border border-white/20 shadow-2xl bg-white/40 p-2">
        <div className="bg-white flex flex-col items-center space-y-6 p-3 rounded-2xl">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
            <UserIcon className="w-8 h-8 text-gray-600" />
          </div>

          <div className="text-center">
            <h3 className="text-lg font-medium text-gray-900">
              {user?.name || "Usuario"}
            </h3>
            <p className="text-sm text-gray-500 mt-1">{user?.email}</p>
          </div>

          <div className="w-full h-px bg-gray-200"></div>

          <Button
            onClick={logout}
            className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-3 px-6 rounded-2xl transition-colors duration-200 flex items-center justify-center gap-2"
          >
            <LogOut className="w-4 h-4" />
            Cerrar sesión
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
